import React, { useState, useRef, useEffect } from 'react';
import Container from '@mui/material/Container';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import FormHelperText from '@mui/material/FormHelperText';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useDispatch, useSelector } from 'react-redux';
import { setAdditionalData, setCodpmpol, setBeneficiaryData, setCurrentTab, setDeleteBeneficiaryData, setGlobalTab, setHandleChangeBeneficiary, setTypeBeneficiary, setErrorEncrypt, setFirstStep, setTitularData, setFirstFormCompleted } from '../redux/reducer/stepReducer/stepReducer';
import CardBenData from '../components/CardBenData';
import ClearIcon from "@mui/icons-material/Clear";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { useNavigate, useSearchParams } from 'react-router-dom';
import dayjs from 'dayjs';
import Layout from '../components/Layout';
import { parseISO } from 'date-fns';
import 'dayjs/locale/en-gb';
import { Fade, Modal } from '@mui/material';
import { handleKeyDown, handleKeyDown2, strToDate, validarFecha, isElderlyDate } from '../utilities';
import { createErrorEmail, saveBeneficiary } from '../redux/reducer/stepReducer/thunks';
import Spinner from '../components/Spinner';


const initialStateError = {
  family: false,
  dni: false,
  elderly: false,
  name: false,
  nameLength: false,
  lastname: false,
  invalidLastname: false,
  birthday: false,
  age: false,
  email: false,
  fourEmail: false,
  atsignEmail: false,
  domainEmail: false,
  spaceEmail: false,
  area: false,
  phone: false,
  phoneLength: false,
  percent: false,
};

const customStyles = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '287px',
  bgcolor: '#ECE6F0',
  borderRadius: '20px',
  p: '16px',
};

const BeneficiaryData = ({ handleTabClick, setFormCompleted }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { beneficiaryData, firstStep, titularData, typeBeneficiary, codpmpol } = useSelector((state) => state.firstStep);
  const data = useSelector(state => state.adminReducer.login);
  const [emptyProperties, setEmptyProperties] = useState([]);
  const [error, setError] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [completedCheck, setCompletedCheck] = useState(false);
  const [dataCompleted, setDataCompleted] = useState(null);
  const [searchParams] = useSearchParams();
  const onEdit = searchParams.get('onEdit');
  const [expanded, setExpanded] = useState(onEdit || false);
  const { relationship } = data;
  const [checkedItems, setCheckedItems] = useState({
    otherBeneficiaries: false,
    legalBeneficiaries: true,
  });

  // const dateString = {beneficiaryData.birthday} // Tu cadena de fecha en el formato proporcionado

  // const dateObject = new Date(dateString); // Crea un objeto Date a partir de la cadena

  // const formattedDate = dayjs(dateObject).format('DD-MM-YYYY'); // Formatea la fecha en el formato deseado

  const initialStateData = {
    family: '',
    dni: '',
    name: '',
    lastname: '',
    birthday: '',
    email: '',
    area: '',
    phone: '',
    percent: '',
    order: '',
  };

  const formContainerRef = useRef(null);
  const familyRef = useRef(null);
  const nameRef = useRef(null);
  const lastnameRef = useRef(null);
  const dniRef = useRef(null);
  const birthdayRef = useRef(null);
  const emailRef = useRef(null);
  const areaRef = useRef(null);
  const phoneRef = useRef(null);
  const percentRef = useRef(null);

  const handleOtherBeneficiaries = () => {
    if (beneficiaryData.length > 0) return;
    dispatch(setBeneficiaryData([initialStateData]));
    setError([...error, initialStateError]);
  };

  const handleAddBeneficiary = () => {
    setError([...error, initialStateError]);
    let found = 0;
    let index = [];
    let errorProperty = [];
    const notAllowedEmpty = ['family', 'name', 'lastname'];
    beneficiaryData?.forEach((e, ix) => {
      for (const prop in e) {
        if (e[prop] === '' && notAllowedEmpty.includes(prop)) {
          found = found + 1;
          index.push(ix);
          errorProperty.push(prop);
        };
      };
    });
    if (found > 0) {
      setDataCompleted(false);
      const newError = error?.map((item, i) => {
        if (i === index[0]) {
          return { ...item, [errorProperty[0]]: true };
        } else {
          return item;
        }
      });
      setError(newError);
      index = [];
      errorProperty = [];
      formContainerRef.current.focus();
      formContainerRef.current.scrollIntoView({ behavior: 'smooth' });
    }
    else dispatch(setBeneficiaryData([initialStateData]));
  };

  const handleChange = (name, value, ix) => {
    const arrBeneficiaries = beneficiaryData.map((item, i) => {
      if (i === ix) {
        if (name === 'dni' || name === 'area' || name === 'percent') {
          if (Number(value) < 0) {
            return { ...item, [name]: '' };
          }
          else return { ...item, [name]: value };
        }
        else return { ...item, [name]: value };
      } else {
        return item;
      }
    });
    dispatch(setHandleChangeBeneficiary(arrBeneficiaries));
    const newError = error?.map((item, i) => {
      if (i === ix) {
        if (name === 'name') return {
          ...item, 'name': false, 'nameLength': false
        }
        else if (name === 'lastname') return {
          ...item, 'lastname': false, 'invalidLastname': false
        }
        else if (name === 'email') return {
          ...item,
          'email': false,
          'fourEmail': false,
          'atsignEmail': false,
          'domainEmail': false,
          'spaceEmail': false
        };
        else if (name === 'phone') return {
          ...item, 'phone': false, 'phoneLength': false
        }
        else if (name === 'birthday') return {
          ...item,
          'birthday': false,
          'elderly': false,
          'age': false,
        }
        else return { ...item, [name]: false };
      }
      else return item;
    }
    );
    setError(newError);
  };

  const onNextPage = () => {
    dispatch(setCurrentTab(2));
    dispatch(setGlobalTab(2.6));
    sendInformationToBeneficiaryData();
  };

  const handleBackButton = () => {
    if (expanded && completedCheck) handleClearClick();
    else {
      dispatch(setFirstFormCompleted(true));
      navigate('/datosTitular')
    };
  };

  const handleClearClick = () => {
    dispatch(setHandleChangeBeneficiary([]));
    localStorage.removeItem("typeBeneficiary");
    localStorage.removeItem("checkedItems");
    localStorage.removeItem("expanded");
    localStorage.removeItem("completedCheck");
    setCompletedCheck(false);
    setExpanded(false);
  };

  const removeBeneficiary = async (ix) => {
    if (beneficiaryData.length > 1) {
      await dispatch(setDeleteBeneficiaryData(ix));
      const newError = error.splice(ix, 1)
      setError(newError);
      return;
    } else {
      localStorage.removeItem("typeBeneficiary");
      localStorage.removeItem("checkedItems");
      localStorage.removeItem("expanded");
      localStorage.removeItem("completedCheck");
      await dispatch(setDeleteBeneficiaryData(0));
      setError([]);
      setCompletedCheck(false);
      setExpanded(false);
    };
  };

  const handleSubmit = () => {
    let found = 0;
    let index = [];
    let errorProperty = [];
    beneficiaryData?.forEach((e, ix) => {
      for (const prop in e) {
        if (prop === 'family') {
          if (e[prop] === '') {
            found = found + 1;
            index.push(ix);
            errorProperty.push(prop);
            familyRef.current.focus();
            formContainerRef.current.scrollIntoView({ behavior: 'smooth' });
          }
        }
        if (prop === 'dni') {
          if (e[prop].length > 1 && e[prop].length < 7) {
            found = found + 1;
            index.push(ix);
            errorProperty.push(prop);
            dniRef.current.focus();
            formContainerRef.current.scrollIntoView({ behavior: 'smooth' });
          };
        };
        if (prop === 'name') {
          if (e[prop] === '') {
            found = found + 1;
            index.push(ix);
            errorProperty.push(prop);
            nameRef.current.focus();
            formContainerRef.current.scrollIntoView({ behavior: 'smooth' });
          }
          else {
            let nameLength = e[prop].length;
            if (nameLength < 3) {
              found = found + 1;
              index.push(ix);
              errorProperty.push('nameLength');
              nameRef.current.focus();
              formContainerRef.current.scrollIntoView({ behavior: 'smooth' });
            }
          }
        };
        if (prop === 'lastname') {
          if (e[prop] === '') {
            found = found + 1;
            index.push(ix);
            errorProperty.push(prop);
            lastnameRef.current.focus();
            formContainerRef.current.scrollIntoView({ behavior: 'smooth' });
          }
          let invalidLastname = e[prop].length;
          if (invalidLastname < 3) {
            found = found + 1;
            index.push(ix);
            errorProperty.push('invalidLastname');
            lastnameRef.current.focus();
            formContainerRef.current.scrollIntoView({ behavior: 'smooth' });
          }
        };
        if (prop === 'birthday') {
          if (e[prop] === '') {
            continue;
          }
          const fechaIngresada = dayjs(e[prop]).format('DD/MM/YYYY');
          const age = validarFecha(fechaIngresada);
          const elderly = isElderlyDate(fechaIngresada);
          if (elderly) {
            found = found + 1;
            index.push(ix);
            errorProperty.push('elderly');
            // birthdayRef.current.focus();
            formContainerRef.current.scrollIntoView({ behavior: 'smooth' });
          }
          if (!age) {
            found = found + 1;
            index.push(ix);
            errorProperty.push('age');
            birthdayRef.current.focus();
            formContainerRef.current.scrollIntoView({ behavior: 'smooth' });
          }
        };
        if (prop === 'email') {
          if (e[prop].trim() === '') {
            continue;
          }
          if (!/@/.test(e[prop])) {
            found = found + 1;
            index.push(ix);
            errorProperty.push('atsignEmail');
            emailRef.current.focus();
            formContainerRef.current.scrollIntoView({ behavior: 'smooth' });
          }
          if (!/\.[a-zA-Z]{2,}$/.test(e[prop])) {
            found = found + 1;
            index.push(ix);
            errorProperty.push('domainEmail');
            emailRef.current.focus();
            formContainerRef.current.scrollIntoView({ behavior: 'smooth' });
          }
          if (e[prop].split('@')[0].length < 4) {
            found = found + 1;
            index.push(ix);
            errorProperty.push('fourEmail');
            emailRef.current.focus();
            formContainerRef.current.scrollIntoView({ behavior: 'smooth' });
          }
          if (e[prop].split(' ').length > 1) {
            found = found + 1;
            index.push(ix);
            errorProperty.push('spaceEmail');
            emailRef.current.focus();
            formContainerRef.current.scrollIntoView({ behavior: 'smooth' });
          }
          if (!/^.{4,}@[^@\s]+\.[^@\s]+$/.test(e[prop])) {
            found = found + 1;
            index.push(ix);
            errorProperty.push(prop);
            emailRef.current.focus();
            formContainerRef.current.scrollIntoView({ behavior: 'smooth' });
          }
        };
        if (prop === 'area') {
          if (e[prop].length === 1 || e[prop][0] == "0") {
            found = found + 1;
            index.push(ix);
            errorProperty.push(prop);
            areaRef.current.focus();
            formContainerRef.current.scrollIntoView({ behavior: 'smooth' });
          }
        };
        if (prop === 'phone') {
          const area = e.area;
          const phone = e[prop];
          const phoneLength = area.length + phone.length;
          if ((phone.trim() !== '' & area.trim() === '') || (area.trim() !== '' && phone.trim() === '')) {
            found = found + 1;
            index.push(ix);
            errorProperty.push(prop);
            phoneRef.current.focus();
            formContainerRef.current.scrollIntoView({ behavior: 'smooth' });
          }
          if ((phone.trim() !== '' || area.trim() !== '') && (phoneLength !== 10)) {
            found = found + 1;
            index.push(ix);
            errorProperty.push('phoneLength');
            phoneRef.current.focus();
            formContainerRef.current.scrollIntoView({ behavior: 'smooth' });
          }
        };
        let totalPercent = 0;
        if (prop === 'percent') {
          if (e[prop] === '') {
            found = found + 1;
            index.push(ix);
            errorProperty.push(prop);
            percentRef.current.focus();
            formContainerRef.current.scrollIntoView({ behavior: 'smooth' });
          }
          beneficiaryData.forEach(beneficiaryData => {
            totalPercent += Number(beneficiaryData.percent);
          });
          if (beneficiaryData.length === 3 && (totalPercent < 99 || totalPercent > 100)) {
            found = found + 1;
            index.push(ix);
            errorProperty.push(prop);
            if (errorProperty[0] == 'percent') setModalIsOpen(true);
          }
          else if (totalPercent !== 100) {
            found = found + 1;
            index.push(ix);
            errorProperty.push(prop);
            if (errorProperty[0] == 'percent') setModalIsOpen(true);
          }
        };
      };
    });
    if (found > 0) {
      setDataCompleted(false);
      const newError = error?.map((item, i) => {
        if (i === index[0]) {
          return { ...item, [errorProperty[0]]: true };
        } else {
          return item;
        }
      });
      setError(newError);
      index = [];
      errorProperty = [];
      return;
    }
    else {
      return true;
    }
  };

  const sendInformationToBeneficiaryData = async () => {
    setIsLoading(true);
    if (checkedItems.legalBeneficiaries) {
      await dispatch(saveBeneficiary(checkedItems.legalBeneficiaries, "", codpmpol));
    } else {
      beneficiaryData?.forEach((beneficiary, ix) =>
        dispatch(
          saveBeneficiary(
            checkedItems.legalBeneficiaries,
            {
              ...beneficiary,
              order: ix + 1,
              birthday: beneficiary.birthday ? dayjs(strToDate(beneficiary.birthday)).format('DD/MM/YYYY') : '',
            },
            codpmpol,
            beneficiaryData.length,
          )
        ));
    };
    setIsLoading(false);
    return checkedItems.legalBeneficiaries ? navigate('/pago') : navigate('/detalleBeneficiario');
  };

  const handleGoToPayment = () => {
    localStorage.setItem("checkedItems", JSON.stringify(checkedItems));
    if (checkedItems.legalBeneficiaries && !checkedItems.otherBeneficiaries) {
      setCompletedCheck(true);
      dispatch(setCurrentTab(3));
      dispatch(setTypeBeneficiary('legal'));
      localStorage.setItem("completedCheck", JSON.stringify(completedCheck));
      localStorage.setItem("typeBeneficiary", JSON.stringify('legal'));
      sendInformationToBeneficiaryData();
    };
    if (completedCheck && handleSubmit()) return onNextPage();
    if (checkedItems.otherBeneficiaries && !checkedItems.legalBeneficiaries) {
      dispatch(setTypeBeneficiary('other'));
      localStorage.setItem("expanded", JSON.stringify(true));
      localStorage.setItem("typeBeneficiary", JSON.stringify('other'));
      localStorage.setItem("completedCheck", JSON.stringify(true));
      setExpanded(true);
      setCompletedCheck(true);
      handleOtherBeneficiaries();
    };
  };

  const handleChangeChecked = (index) => {
    if (index === 0) {
      if (checkedItems.legalBeneficiaries) {
        setCheckedItems({ ...checkedItems, legalBeneficiaries: false });
      } else {
        dispatch(setBeneficiaryData([]));
        setCheckedItems({ ...checkedItems, legalBeneficiaries: true, otherBeneficiaries: false });
      }
    } else {
      if (checkedItems.otherBeneficiaries) {
        setCheckedItems({ ...checkedItems, otherBeneficiaries: false });
      } else {
        setCheckedItems({ ...checkedItems, otherBeneficiaries: true, legalBeneficiaries: false });
      }
    }
  };


  useEffect(() => {
    if (emptyProperties.length === 0) setDataCompleted(null);
  }, [emptyProperties]);

  useEffect(() => {
    dispatch(setAdditionalData('Datos de beneficiario'));
    dispatch(setCurrentTab(2))

    return () => {
      dispatch(setAdditionalData(''));
    };
  }, []);

  useEffect(() => {
    if (typeBeneficiary == '') {
      setCompletedCheck(false);
      setCheckedItems({
        otherBeneficiaries: false,
        legalBeneficiaries: true,
      });
    }
    if (typeBeneficiary == 'other' && beneficiaryData.length > 0) {
      const newError = [];
      beneficiaryData?.map((e) => newError.push(initialStateError));
      setError(newError);
      setCompletedCheck(true);
      setExpanded(true);
      setCheckedItems({
        otherBeneficiaries: true,
        legalBeneficiaries: false,
      });
    };
  }, []);

  useEffect(() => {
    let storage = JSON.parse(localStorage.getItem('checkedItems'));
    if (storage?.legalBeneficiaries) {
      setCompletedCheck(false);
      setCheckedItems({
        otherBeneficiaries: false,
        legalBeneficiaries: true,
      });
    };
  }, []);


  useEffect(() => {
    if (!codpmpol) {
      try {
        const getLocalStorageCodpmpol = () => { return JSON.parse(localStorage.getItem('codpmpol')) || [] };
        const storageCodpmpol = getLocalStorageCodpmpol();
        if (Array.isArray(storageCodpmpol)) {
          const getFirstStepStorage = () => { return JSON.parse(localStorage.getItem('firstStep')) || [] };
          const getTitularDataStorage = () => { return JSON.parse(localStorage.getItem('titularData')) || [] };
          let first_step_storage = getFirstStepStorage();
          let titular_data_storage = getTitularDataStorage()
          let message = `Error Recid | Beneficiary Data | Intencion: ${first_step_storage.nro} | DNI TITULAR: ${titular_data_storage.dni} | NOMBRE TITULAR: ${titular_data_storage.name + ' ' + titular_data_storage.lastname}`
          dispatch(createErrorEmail(message));
          dispatch(setErrorEncrypt(true))
          navigate('/error');
        } else {
          dispatch(setCodpmpol(storageCodpmpol));
          const dataFirstStep = JSON.parse(localStorage.getItem('firstStep'));
          dispatch(setFirstStep({ ...firstStep, ...dataFirstStep }));
          const dataTitular = JSON.parse(localStorage.getItem("titularData"));
          dispatch(setTitularData({ ...titularData, ...dataTitular, birthday: '' }));
          const dataBeneficiaryData = JSON.parse(localStorage.getItem("beneficiaryData"))
          const completedCheck = JSON.parse(localStorage.getItem("completedCheck"))
          const checkedItems = JSON.parse(localStorage.getItem("checkedItems"))
          const expanded = JSON.parse(localStorage.getItem("expanded"))
          if (dataBeneficiaryData && dataBeneficiaryData?.length > 0) {
            dispatch(setBeneficiaryData(dataBeneficiaryData.map(ben => ({ ...ben, birthday: '' }))));
            const newError = [];
            beneficiaryData?.map((e) => newError.push(initialStateError));
            setError(newError);
          }
          if (completedCheck) setCompletedCheck(completedCheck)
          if (checkedItems) setCheckedItems(checkedItems)
          if (expanded) setExpanded(expanded)
        };
      } catch (error) {
        let message = `Error en Beneficiarios | Error: ${error}`
        dispatch(createErrorEmail(message));
        dispatch(setErrorEncrypt(true))
        navigate('/error');
      }
    }
  }, []);

  useEffect(() => {
    if (beneficiaryData.length > 0) localStorage.setItem("beneficiaryData", JSON.stringify(beneficiaryData));
  }, [beneficiaryData]);


  return (
    <div className='testdiv' >
      {
        isLoading ?
          <Spinner /> :
          <Layout>
            <Container sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                {
                  !completedCheck && (
                    <>
                      <p style={{ marginBottom: 10, marginTop: 10 }}>Quiero asegurar a mis</p>
                      <CardBenData checkedItems={checkedItems} setCheckedItems={setCheckedItems} handleChangeChecked={handleChangeChecked} />
                    </>
                  )
                }
                {
                  expanded && (
                    <div ref={formContainerRef} className="forms">
                      {
                        beneficiaryData.length > 0 &&
                        <Stack direction={"row"} display={"flex"} justifyContent={"center"}><p>Ingresá los datos de beneficiario</p></Stack>
                      }
                      {
                        beneficiaryData?.map((e, ix) => (
                          <Box
                            key={`beneficiario-${ix + 1}`}
                            sx={{
                              display: 'flex',
                              flexDirection: 'column',
                              alignItems: 'center',
                              justifyContent: 'center',
                              marginTop: 3,
                            }}
                          >
                            <Accordion expanded={expanded}>
                              <AccordionSummary
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                                expandIcon={expanded &&
                                  <ClearIcon onClick={() => removeBeneficiary(ix)} />}>
                                <Stack display={'flex'} direction={"row"} alignItems={'center'} justifyContent={'center'} >
                                  <Typography style={{ fontFamily: 'Roboto', fontWeight: '900', marginLeft: '7px' }}>Beneficiario {ix + 1}</Typography>
                                </Stack>
                              </AccordionSummary>

                              <AccordionDetails>
                                <Typography style={{ fontFamily: 'Roboto' }}>
                                  <FormControl sx={{ m: 1, width: '30ch' }} error={error[ix]?.family}>
                                    <InputLabel id="demo-simple-select-label">Parentesco</InputLabel>
                                    <Select
                                      value={beneficiaryData[ix]?.family}
                                      label="Parentesco"
                                      onChange={({ target }) => handleChange('family', target.value, ix)}
                                      ref={familyRef}
                                    >
                                      <MenuItem value={''}>Parentesco</MenuItem>
                                      {
                                        relationship?.map((e) => (
                                          <MenuItem value={e.value}>{e.label}</MenuItem>
                                        ))
                                      }
                                    </Select>
                                    {error[ix]?.family && <FormHelperText>Seleccione un Parentesco</FormHelperText>}
                                  </FormControl>
                                  <Box component="form" sx={{ '& > :not(style)': { m: 1, width: '30ch' } }} noValidate autoComplete="off">
                                    <TextField
                                      label="DNI (Solo personas físicas)"
                                      variant="outlined"
                                      name="dni"
                                      type='number'
                                      ref={dniRef}
                                      onKeyDown={handleKeyDown}
                                      onChange={({ target }) => {
                                        let updatedValue = target.value;
                                        updatedValue = updatedValue.slice(0, 8);
                                        handleChange('dni', updatedValue, ix)
                                      }}
                                      value={beneficiaryData[ix]?.dni}
                                      error={error[ix]?.dni}
                                      helperText={error[ix]?.dni ? 'DNI requiere 7 u 8 dígitos' : ''}
                                    />
                                  </Box>
                                  <Box component="form" sx={{ '& > :not(style)': { m: 1, width: '30ch' } }} noValidate autoComplete="off">
                                    <TextField
                                      label="Nombre"
                                      variant="outlined"
                                      ref={nameRef}
                                      name="name"
                                      onKeyDown={handleKeyDown2}
                                      onChange={({ target }) => {
                                        let updatedValue = target.value;
                                        updatedValue = updatedValue.slice(0, 50);
                                        updatedValue = updatedValue.replace(/[^a-zA-ZáéíóúÁÉÍÓÚñÑ\s-]/g, '');
                                        handleChange('name', updatedValue, ix)
                                      }}
                                      value={beneficiaryData[ix]?.name}
                                      error={error[ix]?.name || error[ix]?.nameLength}
                                      helperText={(error[ix]?.nameLength && 'Verifique nombre') || (error[ix]?.name && 'Nombre es requerido') || ''}
                                    />
                                  </Box>
                                  <Box component="form" sx={{ '& > :not(style)': { m: 1, width: '30ch' } }} noValidate autoComplete="off">
                                    <TextField
                                      label="Apellido"
                                      variant="outlined"
                                      name="lastname"
                                      onKeyDown={handleKeyDown2}
                                      ref={lastnameRef}
                                      onChange={({ target }) => {
                                        let updatedValue = target.value;
                                        updatedValue = updatedValue.slice(0, 50);
                                        updatedValue = updatedValue.replace(/[^a-zA-ZáéíóúÁÉÍÓÚñÑ\s-]/g, '');
                                        handleChange('lastname', updatedValue, ix)
                                      }}
                                      value={beneficiaryData[ix]?.lastname}
                                      error={error[ix]?.lastname || error[ix]?.invalidLastname}
                                      helperText={(error[ix]?.invalidLastname && 'Verifique apellido') || (error[ix]?.lastname && 'Apellido es requerido') || ''}
                                    />
                                  </Box>
                                  <div onKeyDown={handleKeyDown}>
                                    <Box component="form" sx={{ '& > :not(style)': { m: 1, width: '30ch' } }} noValidate autoComplete="off">
                                      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
                                        <DesktopDatePicker
                                          format="D/MM/YYYY"
                                          // defaultValue={dayjs('2022-04-17')}
                                          variant="outlined"
                                          name='birthday'
                                          label="Fecha de Nacimiento"
                                          ref={birthdayRef}
                                          value={beneficiaryData[ix]?.birthday/* ? parseISO(beneficiaryData[ix]?.birthday) : ''*/}
                                          onChange={(date) => {
                                            // const formattedDate = dayjs(date).format('DD/MM/YYYY');
                                            handleChange('birthday', date, ix);
                                          }}
                                          slotProps={{
                                            textField: {
                                              error: error[ix]?.birthday || error[ix]?.age || error[ix]?.elderly,
                                              helperText: error[ix]?.age ? 'Debe ser mayor de 18 años' : error[ix]?.elderly ? 'Verifique fecha de nacimiento' : '',
                                            }
                                          }}
                                        />
                                      </LocalizationProvider>
                                    </Box>
                                  </div>
                                  <Box component="form" sx={{ '& > :not(style)': { m: 1, width: '30ch' } }} noValidate autoComplete="off">
                                    <TextField
                                      label="Email"
                                      variant="outlined"
                                      name="email"
                                      onKeyDown={handleKeyDown2}
                                      value={beneficiaryData[ix]?.email}
                                      ref={emailRef}
                                      onChange={({ target }) => {
                                        let updatedValue = target.value.trim();
                                        updatedValue = updatedValue.replace(/[^a-zA-Z0-9\s!@#$%^&*()-_+=<>?/:;{}[\]|]/g, '');
                                        handleChange('email', updatedValue, ix)
                                      }}
                                      error={error[ix]?.email || error[ix]?.fourEmail || error[ix]?.atsignEmail || error[ix]?.domainEmail || error[ix]?.spaceEmail}
                                      helperText={(error[ix]?.email && 'Verifique email') || (error[ix]?.fourEmail && 'El email debe tener al menos 4 caracteres antes del @') || (error[ix]?.atsignEmail && 'El email debe contener @') || (error[ix]?.domainEmail && 'El email debe tener un dominio válido (por ejemplo, .com)') || (error[ix]?.spaceEmail && 'El email no debe incluir espacios') || ''}
                                    />
                                  </Box>
                                  <Box component="form" sx={{ '& > :not(style)': { m: 0.8, width: '9ch' } }} noValidate autoComplete="off">
                                    <FormHelperText>Teléfono</FormHelperText>
                                    <TextField
                                      label="Sin 0"
                                      variant="outlined"
                                      name="area"
                                      type="number"
                                      onKeyDown={handleKeyDown}
                                      value={beneficiaryData[ix]?.area}
                                      ref={areaRef}
                                      onChange={({ target }) => {
                                        let updatedValue = target.value;
                                        updatedValue = updatedValue.slice(0, 4);
                                        updatedValue = updatedValue.replace(/\./g, '');
                                        handleChange('area', updatedValue, ix)
                                      }}
                                      error={error[ix]?.area}
                                      helperText={error[ix]?.area ? 'Verifique area' : ''}
                                    />
                                    <TextField
                                      style={{ width: '20ch' }}
                                      label="Sin 15"
                                      variant="outlined"
                                      name="phone"
                                      type="number"
                                      ref={phoneRef}
                                      onKeyDown={handleKeyDown}
                                      value={beneficiaryData[ix]?.phone}
                                      onChange={({ target }) => {
                                        let updatedValue = target.value;
                                        updatedValue = updatedValue.slice(0, 8);
                                        updatedValue = updatedValue.replace(/[^0-9]/g, '');
                                        handleChange('phone', updatedValue, ix)
                                      }}
                                      error={error[ix]?.phone || error[ix]?.phoneLength}
                                      helperText={(error[ix]?.phone && 'Verifique telefono') || (error[ix]?.phoneLength && 'Verifique telefono y area') || ''}
                                    />
                                    <div className="texthelper">
                                      <FormHelperText>Código de área</FormHelperText>
                                      <FormHelperText>Número telefónico</FormHelperText>
                                    </div>
                                  </Box>
                                  <Box component="form" sx={{ '& > :not(style)': { m: 1, width: '30ch' } }} noValidate autoComplete="off">
                                    <TextField
                                      label="Porcentaje"
                                      variant="outlined"
                                      name="percent"
                                      type='number'
                                      onKeyDown={handleKeyDown2}
                                      ref={percentRef}
                                      value={beneficiaryData[ix]?.percent}
                                      onChange={({ target }) => {
                                        let updatedValue = target.value;
                                        updatedValue = updatedValue.slice(0, 5);
                                        handleChange('percent', updatedValue, ix)
                                      }}
                                      error={error[ix]?.percent || error[ix]?.totalPercent}
                                      helperText={error[ix]?.percent ? 'Revise el porcentaje' : ''}
                                    />
                                  </Box>
                                  <Stack direction="row" display={"flex"} justifyContent={"end"} alignItems={"center"}>
                                    <Button
                                      style={{ borderRadius: 20, textTransform: 'capitalize', marginTop: 12, marginRight: 10 }}
                                      size="small"
                                      color="secondary"
                                      variant="outlined"
                                      onClick={handleAddBeneficiary}
                                    >
                                      + Añadir beneficiario
                                    </Button>
                                  </Stack>
                                </Typography>
                              </AccordionDetails>
                            </Accordion>
                          </Box>
                        ))
                      }
                    </div>
                  )}
              </div>
              <div style={{
                display: 'flex', flexDirection: 'row', justifyContent: 'center', marginBottom: '30px', marginTop: '30px', marginLeft: '90px', width: '95%'
              }}>
                <Stack spacing={1} direction="row" justifyContent={'center'}>
                  <Button style={{ borderRadius: 20, textTransform: 'capitalize' }} size="medium" color="error" variant="outlined" onClick={handleBackButton}>Atrás</Button>
                  <Button
                    style={{ borderRadius: 20, textTransform: 'capitalize' }} size="medium" color="error" variant="contained" onClick={handleGoToPayment}
                  >
                    Continuar
                  </Button>
                </Stack>
              </div>
              <Modal
                open={modalIsOpen}
                onClose={() => setModalIsOpen(false)}
                closeAfterTransition
              >
                <Fade in={modalIsOpen}>
                  <Box sx={customStyles}>
                    <Typography id="transition-modal-title" variant="h6" component="h4" style={{ fontFamily: 'Roboto' }}>
                      Porcentaje de beneficiarios
                    </Typography>
                    <Typography variant="body2" sx={{ mt: 1 }} style={{ fontFamily: 'Roboto' }}>
                      Encontramos un error en el porcentaje de los beneficiarios.
                      Verifique que la sumatoria total de todos los beneficiarios sea 100%.
                    </Typography>
                    <div
                      className="contenedorBotones"
                      style={{
                        spacing: 9,
                        display: "flex",
                        flexDirection: "row",
                        margin: 13,
                        position: "relative",
                      }}
                    >
                      <Button
                        style={{ borderRadius: 20, textTransform: "capitalize" }}
                        size="medium"
                        color="secondary"
                        variant="contained"
                        type="submit"
                        onClick={() => setModalIsOpen(false)}
                      >
                        Aceptar
                      </Button>
                    </div>
                  </Box>
                </Fade>
              </Modal>
            </Container>
          </Layout >
      }
    </div >
  )
};

export default BeneficiaryData;
